// import { WEEKDAYS, WEEKEND } from 'modules/customers/customer-edit/constants';

// Weekdays
import Charity from 'assets/images/weekdays/Charity-hover.svg';
import Corporate from 'assets/images/weekdays/Corporate-hover.svg';
import Creative from 'assets/images/weekdays/Creative-hover.svg';
import Entertainment from 'assets/images/weekdays/Entertainment-hover.svg';
import Healthcare from 'assets/images/weekdays/Healthcare-hover.svg';
import Kids from 'assets/images/weekdays/Kids-hover.svg';
import InPersonMeetings from 'assets/images/weekdays/InPersonMeetings-hover.svg';
import Outdoor from 'assets/images/weekdays/Outdoor-hover.svg';
import Research from 'assets/images/weekdays/Research-hover.svg';
import Retail from 'assets/images/weekdays/Retail-hover.svg';
import Studying from 'assets/images/weekdays/Studying-hover.svg';
import Training from 'assets/images/weekdays/Training-hover.svg';
import Technology from 'assets/images/weekdays/Technology-hover.svg';
import Teaching from 'assets/images/weekdays/Teaching-hover.svg';
import WFH from 'assets/images/weekdays/WFH-hover.svg';

// Weekend
import Brunch from 'assets/images/weekend/Brunch-hover.svg';
import CityWalks from 'assets/images/weekend/Citywalks-hover.svg';
import Coffees from 'assets/images/weekend/Coffees-hover.svg';
import Cooking from 'assets/images/weekend/Cooking-hover.svg';
import Datenights from 'assets/images/weekend/Datenights-hover.svg';
import DIY from 'assets/images/weekend/DIY-hover.svg';
import FamilyTime from 'assets/images/weekend/FamilyTime-hover.svg';
import Gardening from 'assets/images/weekend/Gardening-hover.svg';
import Lunches from 'assets/images/weekend/Lunches-hover.svg';
import Netflix from 'assets/images/weekend/Netflix-hover.svg';
import OutdoorActivities from 'assets/images/weekend/OutdoorActivities-hover.svg';
import Party from 'assets/images/weekend/Party-hover.svg';
import Reading from 'assets/images/weekend/Reading-hover.svg';
import Selfcare from 'assets/images/weekend/Selfcare-hover.svg';
import SocialDetox from 'assets/images/weekend/SocialDetox-hover.svg';
import Traveling from 'assets/images/weekend/Travelling-hover.svg';
import WorkingOut from 'assets/images/weekend/WorkingOut-hover.svg';
import WorkWork from 'assets/images/weekend/WorkWork-hover.svg';

export const ICONS = [
    { text: 'Charity', icon: Charity },
    { text: 'Corporate', icon: Corporate },
    { text: 'Creative', icon: Creative },
    { text: 'Media', icon: Entertainment },
    { text: 'Healthcare', icon: Healthcare },
    { text: 'Kids', icon: Kids },
    { text: 'Meetings', icon: InPersonMeetings },
    { text: 'Outdoor', icon: Outdoor },
    { text: 'Research', icon: Research },
    { text: 'Retail', icon: Retail },
    { text: 'Studying', icon: Studying },
    { text: 'Teaching', icon: Teaching },
    { text: 'Technology', icon: Technology },
    { text: 'Training', icon: Training },
    { text: 'Home Office', icon: WFH },

    { text: 'Brunch', icon: Brunch },
    { text: 'City Walks', icon: CityWalks },
    { text: 'Coffees', icon: Coffees },
    { text: 'Cooking', icon: Cooking },
    { text: 'Date Nights', icon: Datenights },
    { text: 'DIY', icon: DIY },
    { text: 'Family Time', icon: FamilyTime },
    { text: 'Gardening', icon: Gardening },
    { text: 'Lunches', icon: Lunches },
    { text: 'Netflix', icon: Netflix },
    { text: 'Activities', icon: OutdoorActivities },
    { text: 'Party', icon: Party },
    { text: 'Reading', icon: Reading },
    { text: 'Selfcare', icon: Selfcare },
    { text: 'Social Detox', icon: SocialDetox },
    { text: 'Traveling', icon: Traveling },
    { text: 'Working Out', icon: WorkingOut },
    { text: 'Work', icon: WorkWork }
];

const IconView = ({ value }) => {
    let result = ICONS.find((d) => d.text === value);

    const icon = result ? result.icon : 'nothing';

    return (
        <div className="column is-2 my-2 mx-1">
            <img src={icon} alt={value} />
            <p key={value}>{value}</p>
        </div>
    )

}

export { IconView };
